module.exports = __webpack_public_path__ + "img/music-test-icon3.3f0fea07.png";